const GENRES = [
  { name: 'Kuduro' },
  { name: 'Semba' },
  { name: 'Deep House' },
  { name: 'Afro Beat' },
  { name: 'Afro Fusion' },
  { name: 'Afro Trap' },
  { name: 'Trap Soul' },
  { name: 'Pagode' },
  { name: 'HipHop/Rap' },
  { name: 'Rap/Trap' },
  { name: 'R&B' },
  { name: 'Reggaeton' },
  { name: 'Latino' },
  { name: 'Kizomba' },
  { name: 'Reggae' },
  { name: 'Rock' },
  { name: 'Dj Mix' },
  { name: 'Naija' },
  { name: 'Pop' },
  { name: 'Jazz' },
  { name: 'Amapiano' },
  { name: 'Afrobeat' },
  { name: 'Scif' },
  { name: 'Instrumental' },
  { name: 'Gospel' },
  { name: 'Zouk' },
  { name: 'Guetto Zouk' },
  { name: 'MPB' }
]
export default GENRES;